var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("router-view", { key: _vm.currentLocale }),
      _vm._v(" "),
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c("vue-snotify"),
      _vm._v(" "),
      _vm.isLoggedIn ? _c("FeaturesUpdateModal") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }